import * as React from "react";
import ITechsupportProps from "./ITechsupport";
import "../../../assets/sass/components/techSupportPopup.scss";
import constantFile from "../../constants/constantFile";
import { imagePathurl } from "../../utils/utils";

/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
const TechSupport: React.FC<ITechsupportProps> = (props) => {
    const onCancelPopup = () => {
        props.closePopup();
        document.body.classList.remove("hideOverflow");
    };
    const getimagePath = imagePathurl();
    return (
        <React.Fragment>
            <div className="gaf-contact-service-container">
                <div className="overlay" onClick={onCancelPopup}>
                    <div
                        className="gaf-contact-popup text-center"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}>
                        <div id="close_popup" className="close-menu" onClick={onCancelPopup}>
                            <img
                                tabIndex={10004}
                                className="delete-form-icon"
                                src={`${getimagePath}close-mobile.png`}
                                alt="close"
                            />
                        </div>
                        <div className="contractor-service-header">{constantFile.contactGafTitle}</div>
                        <img
                            className="contractor-service-logo"
                            src={`${getimagePath}contactus.png`}
                            alt="gaf-service-logo"
                        />
                        <div className="contractor-service-title">{constantFile.contactGafSubTitle}</div>
                        <div className="gaf-service-mail">
                            <a href="mailto:`${constantFile.contactGafMailaddress}`">
                                {constantFile.contactGafMailaddress}
                            </a>
                        </div>
                        <div className="gaf-phone">{constantFile.contactGafPhoneNo}</div>
                        <div className="gaf-work-hours">{constantFile.contactGafWorkHours}</div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default TechSupport;
